module.exports = __webpack_public_path__ + "img/icon-Timer-Blue.4c3e9d01.png";